export function MessengerMediaOrButtonTemplateBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: [
      '<div class="html-element media-or-button-template">',
        '<div class="box-content-container">',
          '<div class="box-content">',
            '<div class="media-template-content">',
              '<img src="" class="hide">',
              '<video preload="auto" controls src="" class="hide"></video>',
            '</div>',          
            '<div class="button-template-content">',
              '<div class="template-text"></div>',
            '</div>',
          '</div>',
          '<div class="item-edit-container"><span class="glyphicon glyphicon-pencil item-edit"></span></div>',
        '</div>',
      '</div>'
    ].join(''),


    initialize: function() {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.item-edit').on('click', () => this.editMediaOrButtonTemplate());
      this.$box.find('img').load(() => {
        if (!services.JointjsOptimisationsFactory.isDeserializingInProgress()) {
          this.resizeBox();
        }
      });
      this.$box.find('video')[0].addEventListener('loadeddata', () => this.resizeBox(), false);
    },


    /**
     * Adds a new button to the template.
     * The button is inserted just before the AddChild child of type 'html.MessengerAddButton'
     * (which is always the last child of the box).
     */
    addChildClicked: function(buttonId) {
      let addButtonChild = null;
      for (let child of this.model.getEmbeddedCells()) {
        if (child.get('type') === 'html.MessengerAddButton') {
          addButtonChild = child;
          this.model.unembed(child);
        }
      }
      const button = new joint.shapes.html.MessengerButton({
        id: buttonId,
        button: {
          title: services.$translate.instant('parameters/quick_replies/details/graph/new_button_label'),
          type: 'postback'
        }
      });
      this.model.embed(button);
      this.model.graph.addCell(button);
      this.model.embed(addButtonChild);
      this.enableOrDisableAddButtons();
      this.resizeBox();
      this.paper.findViewByModel(button).editButton();
    },

    /*
     * cf https://developers.facebook.com/docs/messenger-platform/reference/template/generic/ :
     * each carousel item can have at most 3 buttons.
     * This function updates the 'add button' buttons accordingly.
     */
    enableOrDisableAddButtons: function() {
      let buttonsNumber = 0;
      for (let child of this.model.getEmbeddedCells()) {
        switch (child.get('type')) {
          case 'html.MessengerButton':
            buttonsNumber++; 
            break;
          case 'html.MessengerAddButton':
            child.set('disabled', buttonsNumber >= 3);
            break;
        }
      }
    },


    /**
     * Event handler that shows a modal for editing the generic template 
     */
    editMediaOrButtonTemplate : function() {
      const element = this.model.get('element');
      let modalInstance = services.$uibModal.open({
        animation: true,
        template:  require('../../shared/editTemplateElement.modal.html'),
        controller: 'editTemplateElementController',
          resolve: {
            companyId: () => companyId,
            siteId: () => siteId,
            templateType: () => this.model.get('type'),
            element: () => angular.copy(element),
            modalTitle: () => services.$translate.instant('parameters/quick_replies/details/edit_generic_template_a_mano/title'),
            showRemoveButton: () => false,
            showCompactCheckbox: false
          }
      });
      // Hook callback that will update the model and save the updated graph
      modalInstance.result.then(result => {  
        if (result.type === 'edit') {
          this.model.set('element', result.element);
        }
        callbacks.updateSerializedGraph(this.model.graph);
        this.setMediaOrButtonTemplateHtmlContent();
        this.resizeBox();
      });
    },


    setMediaOrButtonTemplateHtmlContent: function() {
      const element = this.model.get('element');
      switch (this.model.get('type')) {

        case 'html.MessengerMediaTemplateAManoBox':
          let img = this.$box.find('img');
          if (typeof element.pictureId === 'number') {
            img.removeClass('hide');
            services.MediasFactory.pictureUrlWithJWT(companyId, element.pictureId).then((urlWithJwt) => {
              img.attr('src', urlWithJwt);
            });
          } else {
            img.addClass('hide');
          }
          let video = this.$box.find('video');
          if (typeof element.videoId === 'number') {
            video.removeClass('hide');
            services.MediasFactory.videoUrlWithJWT(companyId, element.videoId).then((urlWithJwt) => {
              video.attr('src', urlWithJwt);
            });
          } else {
            video.addClass('hide');
          }
          break;
        case 'html.MessengerButtonTemplateAManoBox':
          this.$box.find('.template-text').text(element.text);
          break;
      }
    },


    afterDeserialize: function(shouldResize) {
      this.setMediaOrButtonTemplateHtmlContent();
      this.enableOrDisableAddButtons();
      if (shouldResize) {
        this.resizeBox();
      }
    },

    
    resizeBox: function() {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('MessengerMediaOrButtonTemplateBoxView - resizeBox()');
      }
      let box = this.model;
      let embeddedCells = box.getEmbeddedCells();
      let paddingTop = this.$box.find('.box-content-container').outerHeight();

      //Reposition and resize every item
      let ypos = paddingTop ;
      for (let child of embeddedCells) {
        let childView = this.paper.findViewByModel(child);
        child.position(0, ypos, {parentRelative: true});
        let childHeight = childView.$box.outerHeight();
        child.resize(box.attributes.size.width, childHeight);
        ypos += childHeight;
      }

      box.fitEmbeds({padding: {top: paddingTop, right: 0, bottom: 0, left: 0}});
      callbacks.resizePaper();
    }
  });
}